import { extendedEvent, method, composeEventName } from '../support';
var defaultOptions = {
    dispatchEvent: true,
    eventPrefix: true
};
var UseVisibility = /** @class */ (function () {
    function UseVisibility(controller, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.observe = function () {
            _this.controller.isVisible = !document.hidden;
            document.addEventListener('visibilitychange', _this.handleVisibilityChange);
        };
        this.unobserve = function () {
            document.removeEventListener('visibilitychange', _this.handleVisibilityChange);
        };
        // private
        this.dispatchInvisible = function (event) {
            var eventName = composeEventName('invisible', _this.controller, _this.eventPrefix);
            _this.controller.isVisible = false;
            _this.controller.invisible && method(_this.controller, 'invisible').call(_this.controller, event);
            _this.dispatch(eventName, event);
        };
        this.dispatchVisible = function (event) {
            var eventName = composeEventName('visible', _this.controller, _this.eventPrefix);
            _this.controller.isVisible = true;
            _this.controller.visible && method(_this.controller, 'visible').call(_this.controller, event);
            _this.dispatch(eventName, event);
        };
        this.dispatch = function (eventName, event) {
            if (_this.dispatchEvent) {
                var visibilityEvent = extendedEvent(eventName, event || null, { controller: _this.controller });
                _this.controller.element.dispatchEvent(visibilityEvent);
            }
        };
        this.handleVisibilityChange = function (event) {
            if (document.hidden) {
                _this.dispatchInvisible(event);
            }
            else {
                _this.dispatchVisible(event);
            }
        };
        var _a = Object.assign(defaultOptions, options), dispatchEvent = _a.dispatchEvent, eventPrefix = _a.eventPrefix;
        Object.assign(this, { dispatchEvent: dispatchEvent, eventPrefix: eventPrefix });
        this.controller = controller;
        // make a copy as tthis.unobserve is not available within Object.assign ??
        var unobserve = this.unobserve;
        var controllerDisconnect = controller.disconnect.bind(controller);
        Object.assign(controller, {
            disconnect: function () {
                unobserve();
                controllerDisconnect();
            }
        });
        // triggers initial callback on connect
        this.handleVisibilityChange();
        this.observe();
    }
    return UseVisibility;
}());
export { UseVisibility };
export var useVisibility = function (controller, options) {
    if (options === void 0) { options = {}; }
    var observer = new UseVisibility(controller, options);
    return [observer.observe, observer.unobserve];
};
//# sourceMappingURL=use-visibility.js.map